window.Taskello = window.Taskello || {};

const LOG_STYLES = {
    info: 'color: #0d6efd; font-weight: 700;',
    warning: 'color: #fd7e14; font-weight: 700;',
    error: 'color: #dc3545; font-weight: 700;'
};

const LOG_METHODS = {
    info: 'info',
    warning: 'warn',
    error: 'error'
};

const normalizeLogType = (type = 'info') => {
    if (type === 'warn') {
        return 'warning';
    }

    if (type === 'danger') {
        return 'error';
    }

    return Object.hasOwn(LOG_STYLES, type) ? type : 'info';
};

const getTimestamp = () => {
    const now = new Date();
    const dateFormatter = new Intl.DateTimeFormat('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const timeFormatter = new Intl.DateTimeFormat('pl-PL', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3,
        hour12: false
    });

    return `${dateFormatter.format(now)} ${timeFormatter.format(now)}`;
};

const logWithType = (type, ...args) => {
    if (!window.Taskello.config?.debug) {
        return;
    }

    const normalizedType = normalizeLogType(type);
    const timestamp = getTimestamp();
    const label = normalizedType.toUpperCase();
    const consoleInstance = globalThis.console;
    const logMethod = consoleInstance?.[LOG_METHODS[normalizedType]] || consoleInstance?.log;

    if (typeof logMethod === 'function') {
        logMethod.call(
            consoleInstance,
            `%c[${timestamp}]%c [${label}]`,
            'color: #6c757d; font-weight: 600;',
            LOG_STYLES[normalizedType],
            ...args
        );
    }
};

window.Taskello.debug = {
    log: (...args) => logWithType('info', ...args),
    info: (...args) => logWithType('info', ...args),
    warning: (...args) => logWithType('warning', ...args),
    error: (...args) => logWithType('error', ...args)
};

window.Taskello.debugLog = (...args) => window.Taskello.debug.info(...args);

window.taskello = window.taskello || {};
window.taskello.debug = window.Taskello.debug;
window.taskello.debugLog = (...args) => window.Taskello.debug.info(...args);
